import debug from 'debug'

export const secretDebug = debug('smartsupp:widget')

export const gaDebug = debug('smartsupp:ga')
